import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

import App from "./App";
import { initWebAnalytics, surfaceForChannel } from "@/lib/posthog";
import "@/styles/tailwind.css";

initWebAnalytics({
  channel: "site",
  surface: surfaceForChannel("site"),
  version: import.meta.env.VITE_APP_VERSION ?? "0.0.0",
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
